

















import { Component, Vue } from 'vue-property-decorator'
import { Toast } from 'vant'
import { submitFeedback, getHelpList } from '../../api'
import { CommonModule } from '@/store/modules/common'

import IOSUpload from './components/IOSUpload.vue'
import QuestionList from './components/QuestionList.vue'
import { isIOS } from '@/common/utils/device/getSystemInfo'
@Component({
  name: 'HelpFeedback',
  components: { QuestionList, IOSUpload }
})
export default class HelpFeedback extends Vue {
  textarea = ''
  isIOS = isIOS
  fileList: Array<UploadFileList> = []
  repeatClick = true
  get userName() {
    return CommonModule.userName
  }

  goCommit() {
    this.$router.push('/help-commit')
  }
  onChange(list: Array<UploadFileList>) {
    this.fileList = list
  }
  helpList: any = []
  async init() {
    const { data } = await getHelpList()
    this.helpList = data.list
  }
  mounted() {
    this.init()
  }
  async submit() {
    if (this.repeatClick) {
      this.repeatClick = false
      const deviceModel = CommonModule.deviceModel
      const images = this.fileList.map(item => item.url)
      if (!this.textarea.length) {
        this.repeatClick = true
        return Toast('请填写反馈内容')
      }
      await submitFeedback({
        model: deviceModel,
        images: JSON.stringify(images),
        content: this.textarea
      })
      this.textarea = ''
      this.fileList = []
      this.repeatClick = true
      Toast('提交成功！')
    }
  }
  get HelpFeedbackSubmitBtn(): ClickEventMap {
    return {
      pageId: 'page_h5_help_feedback',
      eventId: 'HelpFeedbackSubmitBtn',
      eventType: 'liveType',
      targetType: 'liveButton',
      targetName: this.textarea
    }
  }
}
